import { useCallback, useContext } from 'react';

import StoreContext from '../contexts/EditorContext';
import { executeTemplateBuilderOperation } from './execute';
import { useTemplateOperationExtras } from './operationExtrasContext';
import type { TemplateBuilderOperation } from './names';
import type { TemplateOperationResult } from './types';

export function useRunTemplateBuilderOperation(): (
  operation: TemplateBuilderOperation,
  args: Record<string, unknown>,
) => Promise<TemplateOperationResult> {
  const ctx = useContext(StoreContext);
  const operationExtras = useTemplateOperationExtras();

  return useCallback(
    (operation, args) => {
      if (ctx.store === null) {
        return Promise.resolve({
          ok: false,
          invocationId: 'ui-no-store',
          error: {
            code: 'EDITOR_NOT_READY',
            message: 'The Template Builder editor is not ready.',
          },
        });
      }
      return executeTemplateBuilderOperation(
        { source: 'ui', store: ctx.store, ...operationExtras },
        { operation, args },
      );
    },
    [ctx.store, operationExtras],
  );
}
